// /* eslint-disable import/no-cycle */
// import User from '../../models/User';
import isEmptyObj from '@/utilities/isEmptyObj';

const authorization = {
  state: {
    jwtToken: null,
    refreshToken: null,
    loggedIn: false,
    user: {
      name: '',
      email: '',
      isAdmin: false,
      team: '',
      id: '',
      isCommitteeMember: false,
    },
  },
  mutations: {
    logOutUser(state) {
      state.loggedIn = false;
      state.refreshToken = null;
      state.jwtToken = null;
      state.user = {};
    },
    removeCurrentUserFromTeam(state) {
      state.user.team = '';
    },
    setJwtToken(state, newJwtToken) {
      state.jwtToken = newJwtToken;
    },
    setLoggedIn(state, loginVal) {
      state.loggedIn = loginVal;
    },
    setRefreshToken(state, newRefreshToken) {
      state.refreshToken = newRefreshToken;
    },
    setUser(state, userData) {
      const currentUser = {
        ...state.user,
        name: userData.name,
        email: userData.email,
        isCommitteeMember: userData.committeeMember,
        idToken: userData.idToken,
      };
      state.user = currentUser;
      state.jwtToken = userData.accessToken;
      state.refreshToken = userData.refreshToken;
    },
    setUserAdminStatus(state, adminStatus) {
      state.user.isAdmin = adminStatus;
    },
    setUserTeam(state, teamId) {
      state.user.team = teamId;
    },
  },
  actions: {
    logOutUser({ commit, dispatch }) {
      dispatch('setEvent', {});
      commit('logOutUser');
    },
    setJwtToken({ commit }, newJwtToken) {
      commit('setJwtToken', newJwtToken);
    },
    setLoggedIn({ commit }, loggedInVal) {
      commit('setLoggedIn', loggedInVal);
    },
    setRefreshToken({ commit }, newRefreshToken) {
      commit('setRefreshToken', newRefreshToken);
    },
    setUserTeam({ commit }, newTeamId) {
      commit('setUserTeam', newTeamId);
    },
  },
  getters: {
    canAddNewTeam(state) {
      return state.user.team < 0;
    },
    canEditTeam(state, teamId) {
      return state.user.team === teamId || state.user.isAdmin;
    },
    currentJwtToken(state) {
      return state.jwtToken;
    },
    currentRefreshToken(state) {
      return state.refreshToken;
    },
    currentUser(state) {
      return state.user;
    },
    isAuthorized(state) {
      return !isEmptyObj(state.user) && state.loggedIn;
    },
    isLoggedIn(state) {
      return state.loggedIn;
    },
  },
};

export default authorization;
